export default __webpack_public_path__ + "static/media/polygonIcon.1140771b.png";